import { Injectable,OnDestroy } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { firstValueFrom, Subscription } from 'rxjs';
import { ProductNames } from '../dave-data-module/entities/license.entity';
import { State } from '../dave-data-module/State';
import { BaseActionTypes } from '../dave-data-module/State/actions/base.actions';
import { BroadcastService } from './broadcast.service';
import { LocalStorageService } from './local-storage.service';

@Injectable({
    providedIn: 'root',
})
export class LoginService implements OnDestroy {
    private logoutSubscription: Subscription = this.bc.receivedLogout$.subscribe(() => {
        console.log('receivedLogout$');
        this.logout();
    });
    private loginSubscription: Subscription = this.bc.receivedLogin$.subscribe((token) => {
        console.log('receivedLogin$', token);
        this.store.dispatch(BaseActionTypes.UpdateToken({ Payload: token }))
    });
    constructor(private store: Store<State>, private router: Router, private dialog: MatDialog, private bc: BroadcastService, private localStorageService: LocalStorageService) {}


    public async Login(Username: string, Password: string) {
        this.unsetNotifications();
        const trustedDeviceToken = await this.localStorageService.getTrustedDeviceToken(Username || '');
        this.store.dispatch(BaseActionTypes.PerformLoginRequest({ Payload: { Username, Password, trustedDeviceToken } }));
    }

    private async logout() {
        if (this.dialog.openDialogs.length) {
            this.dialog.closeAll();
            await firstValueFrom(this.dialog.afterAllClosed);
        }
        await this.router.navigateByUrl('/login');
        this.store.dispatch(BaseActionTypes.InitStore());
        localStorage.removeItem('token');// wird auch im clearState metaReducer gemacht, aber ich mache es hier trotzdem nochmal damit ich in der logoutsubscription zuverlässig prüfen kann ob ich schon ausgeloggt bin
    }
    public async Logout() {
        await this.logout();
        this.bc.sendLogout();
    }

    private unsetNotifications() {
        for (const value in ProductNames) {
            localStorage.removeItem(ProductNames[value]);
        }
    }
    ngOnDestroy(): void {
        this.logoutSubscription?.unsubscribe();
        this.loginSubscription?.unsubscribe();
    }
}
